import { i18n } from "../../globalization/i18n.js";
import { Editor } from "./Editor.js";


export class Dropdown extends Editor {

    constructor (parent, params = {}) {

        params = Object.assign({
            value: null,
            onValueChange: null,
            valueReturnsData: false,
            valueKeyProp: 'id',
            valueKey: null,
            items: [],
            itemsEmptyText: i18n.t('control.items.select'),
            itemValueProp: 'value',
            itemKey: null,
            itemLabelProp: 'text',
            itemLabel: null,
            onFormatOption: null,
            expanded: false,
            onOpen: function () { },
            onClose: function () { },
            autofocus: false
        }, params || {});

        super(parent, params);

        const {
            valueReturnsData = false,
            valueKeyProp = 'id',
            valueKey = null,
            items = [],
            itemsEmptyText = i18n.t('control.items.select'),
            itemValueProp = 'value',
            itemKey = null,
            itemLabelProp = 'text',
            itemLabel = null,
            onFormatOption = null,
            expanded = false,
            onOpen = function () { },
            onClose = function () { },
            autofocus = false,
        } = params;

        this.valueReturnsData = valueReturnsData;
        this.valueKeyProp = valueKeyProp;
        this.valueKey = valueKey;
        this.items = items;
        this.itemsEmptyText = itemsEmptyText;
        this.itemValueProp = itemValueProp;
        this.itemKey = itemKey;
        this.itemLabelProp = itemLabelProp;
        this.itemLabel = itemLabel;
        this.onFormatOption = onFormatOption || function (option) { return option?.[this.itemLabelProp]; };
        this.expanded = expanded;
        this.onOpen = onOpen;
        this.onClose = onClose;
        this.autofocus = autofocus;

    };

    isAutofocus () {
        return (typeof this.autofocus === 'function' ? this.autofocus() : this.autofocus);
    };

    getValueKeyProp () {

        return (typeof this.valueKeyProp === 'function') ? this.valueKeyProp.call(this) : this.valueKeyProp;

    };

    getValueKey (value) {

        if (this.valueKey && (typeof this.valueKey == 'function'))
            return this.valueKey.call(this, value);
        if (!value)
            return null;
        return value[this.valueKeyProp];

    };

    getItems () {
        return (typeof this.items === 'function' ? this.items.call(this) : this.items);
    };

    getItemValue (item) {

        if (this.itemKey && (typeof this.itemKey == 'function'))
            return this.itemKey.call(this, item);
        if (!item)
            return null;
        return item[this.itemValueProp];

    };

    getItemLabel (item) {

        if (this.itemLabel && (typeof this.itemLabel == 'function'))
            return this.itemLabel.call(this, item);
        if (!item)
            return null;
        return item[this.itemLabelProp];

    };

    // ------------------------------------------------------------------------

    open () {
        this.expanded = true;
        this.onOpen();
        this.invalidate();
    };

    close () {
        this.expanded = false;
        this.onClose();
        this.invalidate();
    };

    toggle () {
        if (this.expanded)
            this.close();
        else
            this.open();
    };

    _render (r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var that = this,
            value = this.getValue(),
            valueKey = this.valueReturnsData ? this.getValueKey(value) : value,
            selectedText,
            selectedOption,
            items = (this.getItems() || []).map(function (option) {
                var itemKey = that.getItemValue(option) || null,
                    optionSelected = itemKey == valueKey ? true : null,
                    itemLabel = that.onFormatOption(option) || that.getItemLabel(option) || '?';
                return {
                    value: itemKey,
                    selected: optionSelected,
                    text: itemLabel,
                    data: option
                };
            }),
            readOnlyOrDisabled = this.isReadOnly() || this.isDisabled();

        if (this.itemsEmptyText) {
            items.push({
                value: null,
                selected: (valueKey === undefined || valueKey === null) ? true : null,
                text: this.itemsEmptyText,
                data: null
            });
        }

        selectedOption = items.find(function (option) {
            return option.selected;
        });

        selectedText = (selectedOption && selectedOption.data) ? (this.onFormatOption(selectedOption.data) || selectedOption.text) : this.itemsEmptyText;

        return renderer.el('div', ['dropdown-selector', this.getCss(), readOnlyOrDisabled ? 'disabled' : (this.expanded ? 'active' : null)].filter(Boolean).join(' '), {}, [
            renderer.el('div', 'selector-editor', { onclick: function () { that.toggle(); } }, [
                selectedText
            ]),
            renderer.el('div', 'selector-toggle', { onclick: function () { that.toggle(); } }, [
                renderer.icon('image')
            ]),
            renderer.el('div', 'selector-menu', {}, [
                renderer.el('ul', 'menu', {}, items.map(function (option) {
                    return renderer.el('li', 'menu-item', {}, [
                        renderer.el('a', null, { onclick: () => onValueChange(option) }, [option.text])
                    ]);
                })),
            ]),
        ]);

        function onValueChange(option) {
            var value = option.value,
                data = (option && option.data) || null;
            that.close();
            that.changeValue(that.valueReturnsData ? data : value);
            that.invalidate();
        };

    };

}